import { FC, HTMLAttributes } from 'react';

type IHanaWalletWalletProps = HTMLAttributes<SVGElement> & {
  size?: number;
};

const HanaWallet: FC<IHanaWalletWalletProps> = ({ size = 16, ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 57 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 6.7326C0 3.27223 2.80519 0.467041 6.26556 0.467041H50.2015C53.6618 0.467041 56.467 3.27223 56.467 6.7326V50.6685C56.467 54.1289 53.6618 56.9341 50.2015 56.9341H6.26556C2.80519 56.9341 0 54.1289 0 50.6685V6.7326Z"
        fill="#0D0229"
      />
      <path
        d="M15.4917 22.8943C15.4917 22.7213 15.6327 22.5815 15.8056 22.5761C20.9471 22.4136 25.0861 18.2747 25.2486 13.1331C25.254 12.9602 25.3938 12.8192 25.5668 12.8192H40.667C40.84 12.8192 40.9803 12.9595 40.9803 13.1325V31.1662C40.9803 31.3392 40.84 31.4795 40.667 31.4795H32.0495C31.8765 31.4795 31.7362 31.3392 31.7362 31.1662V23.8071C31.7362 23.4904 31.308 23.3663 31.1277 23.6266C27.7527 28.5002 22.1578 31.7197 15.8056 31.8225C15.6326 31.8253 15.4917 31.6848 15.4917 31.5118V22.8943Z"
        fill="#E6E0F7"
      />
      <path
        d="M40.9803 35.6809C40.9803 35.5079 40.84 35.3676 40.667 35.3676H15.805C15.632 35.3676 15.4917 35.5079 15.4917 35.6809V44.2984C15.4917 44.4714 15.632 44.6117 15.805 44.6117H40.667C40.84 44.6117 40.9803 44.4714 40.9803 44.2984V35.6809Z"
        fill="#E6E0F7"
      />
    </svg>
  );
};

export default HanaWallet;
